import { TASTY_SHEFS } from 'common/Constants';
import { adjustedStarsToRating } from 'common/RatingUtilities';
import { BowlWithWhisk, StarV2 } from 'src/shared/design-system/Icon';
import Chip, { ChipColor } from 'web-common/src/shared/design-system/components/Chip';
import { getTotalOrderText } from '../checkout/utils';
import NewShefChip from './NewShefChip';
import TasteTestedChip from './TasteTestedChip';

const ShefOrderCount = ({ shefTotalOrders }: { shefTotalOrders: number }) => (
  <div
    className='inline-flex items-center justify-start rounded border border-neutral-100 p-1 
           text-label-600 text-eggplant shadow-none'>
    <div className='mr-1'>
      <BowlWithWhisk width={12} height={12} />
    </div>
    {getTotalOrderText(shefTotalOrders)}
  </div>
);

export const ShefRatingChip = ({
  shefRatingScore,
  shefRatingCount,
}: {
  shefRatingScore: number;
  shefRatingCount: number;
}) => (
  <Chip
    color={ChipColor.BUTTER_100}
    copy={
      <div className='flex items-center gap-2'>
        <StarV2 height={9} width={9} className='mb-1' />
        <span className='text-label-600 text-eggplant'>
          <span className='text-label-700'>{adjustedStarsToRating(shefRatingScore)}</span> ({shefRatingCount})
        </span>
      </div>
    }
  />
);

type ShefDishShowcaseChipsProps = {
  shefId: string;
  shefRatingScore: number;
  shefRatingCount: number;
  shefTotalOrders: number;
  hideRatingCountChip?: boolean;
};
const ShefDishShowcaseChips = ({
  shefId,
  shefRatingCount,
  shefRatingScore,
  shefTotalOrders,
  hideRatingCountChip,
}: ShefDishShowcaseChipsProps) => {
  const isTastyShef = TASTY_SHEFS[shefId];
  if (isTastyShef) {
    return (
      <div className='flex gap-2'>
        {shefTotalOrders < 50 && <NewShefChip />}
        {shefRatingScore < 94 && <TasteTestedChip />}
        {shefRatingScore >= 94 && (
          <ShefRatingChip shefRatingScore={shefRatingScore} shefRatingCount={shefRatingCount} />
        )}
        {!hideRatingCountChip && shefTotalOrders >= 50 && <ShefOrderCount shefTotalOrders={shefTotalOrders} />}
      </div>
    );
  }
  if (shefTotalOrders == null || shefTotalOrders > 5) {
    return (
      <div className='flex items-center gap-2'>
        <ShefRatingChip shefRatingScore={shefRatingScore} shefRatingCount={shefRatingCount} />
        {!hideRatingCountChip && <ShefOrderCount shefTotalOrders={shefTotalOrders} />}
      </div>
    );
  }

  return null;
};

export default ShefDishShowcaseChips;
